webpackJsonp([263791100135453],{

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic06.88498ccc.jpg";

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic13.3f7600f2.jpg";

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic14.f4b19a95.jpg";

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BannerLandingAbout = function BannerLandingAbout(props) {
	    return _react2.default.createElement(
	        "section",
	        { id: "banner", className: "style2" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "header",
	                { className: "major" },
	                _react2.default.createElement(
	                    "h1",
	                    null,
	                    "The Arrangement"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "content" },
	                _react2.default.createElement(
	                    "h2",
	                    null,
	                    "Who created it, and how it was run"
	                )
	            )
	        )
	    );
	};
	
	exports.default = BannerLandingAbout;
	module.exports = exports["default"];

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(25);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _BannerLandingAbout = __webpack_require__(210);
	
	var _BannerLandingAbout2 = _interopRequireDefault(_BannerLandingAbout);
	
	var _pic = __webpack_require__(516);
	
	var _pic2 = _interopRequireDefault(_pic);
	
	var _pic3 = __webpack_require__(520);
	
	var _pic4 = _interopRequireDefault(_pic3);
	
	var _pic5 = __webpack_require__(521);
	
	var _pic6 = _interopRequireDefault(_pic5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Landing = function Landing(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'About'
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'The Arrangement' })
	        ),
	        _react2.default.createElement(_BannerLandingAbout2.default, null),
	        _react2.default.createElement(
	            'div',
	            { id: 'main' },
	            _react2.default.createElement(
	                'section',
	                { id: 'one' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'header',
	                        { className: 'major' },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'The Arrangement'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'In September 2013, six months after the collapse of the Rana Plaza building, the International Labour Organisation hosted a meeting at its Geneva headquarters, convened by IndustriALL Global union. The meeting was attended by representatives of Bangladesh trade unions, several brands and retailers who had been buying from one or more of the Rana Plaza factories, international and Bangladesh NGOs and representatives of the Bangladesh government. The participants agreed to work towards a proposal for calculating loss of income payments, in line with ILO Convention 121, for each of the workers killed and injured at Rana Plaza, provision of medical treatment for those with long term injuries and a system for dispersing those payments that would be credible and transparent. '
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'In December that year these discussions resulted in the signing of an agreement known as the Rana Plaza Arrangement, which established a number of principles upon which resulting payments would be based. The agreement also established the Rana Plaza Coordination Committee, made up of representatives of the Bangladesh government, international clothing brands, national employers, global and local unions and international and local non governmental organisations. Over the following two years, with the ',
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'http://www.ilo.org/global/lang--en/index.htm' },
	                            'International Labour Organisation (ILO)'
	                        ),
	                        ' acting as a neutral chair, the Committee met regularly to negotiate and agree the terms and practical steps for the implementation of the Arrangement. '
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'By October 2015 payments to the beneficiaries of the scheme were complete. In total 34,009,361.96 dollars was paid out to families of the deceased and to workers injured in the collapse. Medical care for those seriously and moderately injured in the collapse is ongoing.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'The payments made under the scheme, along with the operational costs, were funded through contribution made to the Rana Plaza Donors Trust Fund, set up by the ILO for the purposes of collecting donations. The majority of the $30 million collected was contributed by international clothing brands, with the rest paid by the Prime Ministers Fund and other small donors.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                { id: 'two', className: 'spotlights' },
	                _react2.default.createElement(
	                    'section',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/rpcc', className: 'image' },
	                        _react2.default.createElement('img', { src: _pic2.default, alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'inner' },
	                            _react2.default.createElement(
	                                'header',
	                                { className: 'major' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    'The Rana Plaza Coordination Committee'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'The Rana Plaza Coordination Committee was established in order to negotiate the terms of the Arrangement and to oversee its overall implementation. It was made up of representatives of all of the major stakeholders involved in the scheme, including from the Ministry of Labour of the Government of Bangladesh, the local and international garment industry, local and international trade unions and local and international non-governmental organisations. The International Labour Organisation acted as a neutral and independent chair.'
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'actions' },
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _gatsbyLink2.default,
	                                        { to: '/rpcc', className: 'button' },
	                                        'Learn more'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/rpca', className: 'image' },
	                        _react2.default.createElement('img', { src: _pic4.default, alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'inner' },
	                            _react2.default.createElement(
	                                'header',
	                                { className: 'major' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    'The Rana Plaza Claims Administration'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'The Rana Plaza Claims Administration was established in early 2014, in order to implement the day to day work of the Accord. Over seen by three Commissioners, it also employed a team of lawyers, accountants and IT specialists to process the claims, develop and run the calculation software, support the setting up of bank accounts, deal with legal issues and oversee the post claim services. '
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'actions' },
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _gatsbyLink2.default,
	                                        { to: '/rpca', className: 'button' },
	                                        'Learn more'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/commissioners', className: 'image' },
	                        _react2.default.createElement('img', { src: _pic6.default, alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'inner' },
	                            _react2.default.createElement(
	                                'header',
	                                { className: 'major' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    'The Commissioners'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'The Claims Commissioners provided a quasi judicial feature to ensure due process was following in the establishment and delivery of the Arrangement. The Commissioners were responsible for determining the amount of compensation to be awarded to each claimant within the framework agreed upon by the Coordination Committee. They oversaw and certify the correctness and independence of the claims processing and the work of the claims review team.'
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'actions' },
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _gatsbyLink2.default,
	                                        { to: '/commissioners', className: 'button' },
	                                        'Learn more'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Landing;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-7153a5db0ff273b4cf3c.js